<template>
  <div
    ref="textAreaWrapper"
    :data-replicated-value="modelValue"
    class="growable-text-input-fi__grow-wrap"
  >
    <textarea
      id="text"
      :value="modelValue"
      name="text"
      rows="1"
      @input="$emit('input', $event)"
      @focus="$emit('focus', $event)"
      @change.stop="$emit('change', $event)"
      @keyup="$emit('keyup', $event)"
      @keydown="$emit('keydown', $event)"
      @blur="$emit('blur', $event)"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'GrowableTextInputFi',
});

defineProps<{
  modelValue: string | number;
}>();

defineEmits<{
  input: [value: Event];
  focus: [value: FocusEvent];
  change: [value: Event];
  keyup: [value: KeyboardEvent];
  keydown: [value: KeyboardEvent];
  blur: [value: FocusEvent];
}>();
</script>

<style scoped src="./growable-text-input-fi" />
